<script setup lang="ts">
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from '@/components/dropdown-menu'
import { useRouter } from 'vue-router'
import type { MenuItemType } from '@/components/dropdown-menu/types'
import NestedMenuItem from '@/components/dropdown-menu/NestedMenuItem.vue'

const props = defineProps({
  items: {
    type: Array as () => MenuItemType[],
    required: true
  },
  triggerIcon: {
    type: String,
    default: 'more_horiz'
  },
  triggerAriaLabel: {
    type: String,
    default: 'Menu'
  },
  align: {
    type: String as () => 'start' | 'center' | 'end',
    default: 'end'
  }
})

const router = useRouter()

const handleAction = (item: MenuItemType) => {
  if (item.action) {
    item.action()
  } else if (item.route) {
    router.push(item.route)
  }
}
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger 
      class="flex items-center justify-center w-8 h-8 rounded-full text-gray-900 hover:bg-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-600 focus-visible:bg-gray-300"
      :aria-label="triggerAriaLabel"
      aria-haspopup="menu"
    >
      <span class="material-icons-round">{{ triggerIcon }}</span>
    </DropdownMenuTrigger>
    <DropdownMenuContent class="w-40 px-0 py-2" :align="align">
      <template v-for="(item, index) in items" :key="index">
        <NestedMenuItem :item="item" />
      </template>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
